<template>
  <div
    class="
      cabinet-settings
      flex
      column
      bg-white
      mt-55
      mb-144
      pl-55
      pr-55
      pb-60
      pt-30
    "
  >
    <div @click="$router.back()" class="flex al-center pointer go-back mb-34">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7.857"
        height="10"
        viewBox="0 0 7.857 10"
      >
        <path
          id="Icon_material-play-arrow"
          data-name="Icon material-play-arrow"
          d="M19.857,7.5v10L12,12.5Z"
          transform="translate(-12 -7.5)"
          fill="#1a1a1a"
        />
      </svg>
      <span class="f-16 bold ml-10">{{ $fn.tr("უკან") }}</span>
    </div>
    <h2 class="f-21 bold mb-34">
      {{ _.get(this.contentData, "conf.header.title") }}
    </h2>

    <el-input
      :placeholder="$fn.tr('სახელი')"
      v-model="name_field"
      class="mb-30"
      disabled
    ></el-input>
    <el-input
      :placeholder="$fn.tr('გვარი')"
      v-model="lastname_field"
      class="mb-30"
      disabled
    ></el-input>
    <el-input v-model="id_field" class="mb-33" disabled></el-input>

    <div class="flex column mb-30">
      <span class="f-14 uppercase bold mb-16">{{ $fn.tr("სქესი") }}</span>
      <div class="flex">
        <el-radio v-model="sex" label="0" disabled>{{
          $fn.tr("მდედრობითი")
        }}</el-radio>
        <el-radio v-model="sex" label="1" disabled>{{
          $fn.tr("მამრობითი")
        }}</el-radio>
      </div>
    </div>

    <el-input v-model="dob_field" class="mb-30" disabled></el-input>
    <el-input v-model="region_field" class="mb-30" disabled></el-input>

    <div class="cabinet-settings__phone-wrapper flex mb-30" ref="phone_wrapper">
      <el-select v-model="selected_prefix" disabled>
        <el-option
          v-for="prefix in prefixes"
          :key="prefix.id"
          :label="prefix.prefix"
          :value="prefix.prefix"
        >
        </el-option>
      </el-select>
      <el-input v-model="phone_field" disabled></el-input>
    </div>

    <div class="flex cabinet-settings__email-wrapper mb-30">
      <el-input
        :placeholder="$fn.tr('ელ-ფოსტა')"
        v-model="email_field"
        :disabled="change_email_disabled"
      ></el-input>
      <div
        class="flex pointer cabinet-settings__email-wrapper--change"
        @click="change_email"
        v-if="change_email_disabled"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13.737"
          height="15"
          viewBox="0 0 13.737 15"
        >
          <g id="edit-2" transform="translate(-2 -1.161)">
            <path
              id="Path_10258"
              data-name="Path 10258"
              d="M11.881,1.161h0A3.363,3.363,0,0,1,14.15,2.226a3.19,3.19,0,0,1,1.2,2.52,3.426,3.426,0,0,1-1.07,2.092L8.646,12.8a2.644,2.644,0,0,1-1.337.723h0l-2.212.378a2.1,2.1,0,0,1-.355.031,1.716,1.716,0,0,1-1.3-.561,1.819,1.819,0,0,1-.426-1.439l.254-2.227,0-.013a2.748,2.748,0,0,1,.64-1.362l5.64-5.97A3.231,3.231,0,0,1,11.881,1.161ZM7.07,12.174a1.32,1.32,0,0,0,.566-.3l.008-.009,5.639-5.969a2.16,2.16,0,0,0,.7-1.244,1.9,1.9,0,0,0-.773-1.425,2.081,2.081,0,0,0-1.327-.691h0a1.98,1.98,0,0,0-1.336.774L4.906,9.277a1.474,1.474,0,0,0-.278.6L4.375,12.09a.472.472,0,0,0,.085.369.368.368,0,0,0,.278.1.727.727,0,0,0,.123-.011Z"
              transform="translate(-0.312 0)"
              fill="#4d4d4f"
            />
            <path
              id="Path_10259"
              data-name="Path 10259"
              d="M15.321,8.961q-.034,0-.068,0A4.895,4.895,0,0,1,10.9,4.843a.687.687,0,1,1,1.357-.212,3.521,3.521,0,0,0,3.132,2.96.687.687,0,0,1-.067,1.37Z"
              transform="translate(-2.784 -0.905)"
              fill="#4d4d4f"
            />
            <path
              id="Path_10260"
              data-name="Path 10260"
              d="M15.05,22.374H2.687a.687.687,0,1,1,0-1.374H15.05a.687.687,0,0,1,0,1.374Z"
              transform="translate(0 -6.213)"
              fill="#4d4d4f"
            />
          </g>
        </svg>
        <span class="pangram-extrabold ml-10 underline">{{
          $fn.tr("ცვლილება")
        }}</span>
      </div>

      <svg
        v-if="change_email_validated"
        id="email_validated"
        xmlns="http://www.w3.org/2000/svg"
        width="17.559"
        height="12"
        viewBox="0 0 17.559 12"
      >
        <g id="fi-ss-check" transform="translate(0 -4.187)">
          <path
            id="Path_10632"
            data-name="Path 10632"
            d="M5.685,16.187a2.2,2.2,0,0,1-1.563-.646L0,11.42l1.042-1.043L5.163,14.5a.737.737,0,0,0,1.043,0L16.517,4.187,17.559,5.23,7.247,15.541a2.2,2.2,0,0,1-1.563.646Z"
            fill="#28ad25"
          />
        </g>
      </svg>
    </div>
    <div class="flex column" v-if="!change_email_disabled">
      <div class="flex mb-30" v-if="change_email_validated">
        <el-switch
          v-model="email_verification"
          active-color="#28AD25"
          inactive-color="#C9C9CA"
        >
        </el-switch>

        <div class="flex column ml-10">
          <span class="f-13 bold">{{ $fn.tr("ელ-ფოსტის ვერიფიკაცია") }}</span>
          <span class="f-13 bold">{{
            $fn.tr(
              "ელ. ფოსტის მითითებისა და ვერიფიკაციის შემთხვევაში საჩუქრად დაგერიცხებათ 100 სითი ქულა"
            )
          }}</span>
        </div>
      </div>
      <el-input
        v-model="code_field"
        :placeholder="$fn.tr('შეიყვანე კოდი')"
        class="mb-33"
        v-if="email_verification"
      ></el-input>

      <span class="regular f-14 f-red mb-10" v-if="errorMessage">{{
        errorMessage
      }}</span>
      <div
        class="cabinet-settings__btn flex al-center"
        :class="{ disabled: code_field.length === 0 }"
        @click="updateEmail(email_field, code_field)"
      >
        <span class="f-white bold">{{ $fn.tr("შეცვლა") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contentData: Object
  },
  data() {
    return {
      name_field: "",
      lastname_field: "",
      id_field: "",
      sex: "1",
      dob_field: "",
      region_field: "",
      selected_prefix: "",
      phone_field: "",
      email_field: "",
      change_email_disabled: true,
      email_verification: false,
      change_email_validated: false,
      code_field: "",

      errorMessage: ""
    };
  },
  computed: {
    prefixes() {
      return this.$store.state.main.indx.terms.number_prefixes;
    },

    user_info() {
      return _.get(this.$store.state.main.cache, "unicardCards[0]");
    }
  },
  watch: {
    email_verification(ns) {
      if (ns) {
        let obj = {
          mailOtp: "email",
          email: this.email_field,
          phone: this.phone_field
        };
        console.log(obj);
        this.sendEmailCode(obj);
      }
    },
    email_field(ns) {
      if (!this.change_email_disabled) {
        console.log(ns);
        if (ns.includes("@") && ns.includes(".")) {
          console.log("validated");
          this.change_email_validated = true;
        } else {
          this.change_email_validated = false;
        }

        if (this.email_verification) {
          this.email_verification = false;
          this.change_email_validated = false;
          this.errorMessage = "";
        }
      }
    },

    user_info: {
      deep: true,
      immediate: true,
      handler(ns) {
        console.log(ns);
        if (ns !== undefined) {
          this.name_field = ns.firstName;
          this.lastname_field = ns.lastName;
          this.id_field = ns.personCode;
          this.sex = ns.sex.toString();
          this.dob_field = ns.birthDate.substring(0, 10);
          this.region_field = ns.address;
          this.selected_prefix = ns.phoneInfo.countryCode;
          this.phone_field = ns.phoneInfo.phoneNumber;
          this.email_field = ns.email;
        }
      }
    }
  },
  methods: {
    change_email() {
      this.change_email_disabled = false;
    },
    async sendEmailCode(params) {
      const res = await this.$fn.postData(
        "main/serviceCaller?callerId=CityMall_VerifyCode",
        params
      );
    },

    async updateEmail(email, otp) {
      if (!this.$cookies.get("_uctoken")) return false;

      const res = await this.$fn.postData(
        "main/serviceCaller?callerId=CityMall_UpdateEmail",
        {
          uctoken: this.$cookies.get("_uctoken"),
          email,
          otp
        }
      );

      console.log(res);
      console.log(this.errorMessage);
      if (res.status !== 200) {
        return false;
      }
      if (_.get(res, "data.info.ErrorMessage")) {
        this.errorMessage = _.get(res, "data.info.ErrorMessage");
        return;
      }

      this.change_email_disabled = true;
      this.change_email_validated = false;
    }
  }
};
</script>

<style lang="scss">
.cabinet-settings {
  width: 962px;
  .go-back {
    span {
      transition: 0.2s;
    }
    @include hover {
      span {
        color: $red;
      }
    }
  }
  input {
    height: 60px;
    border-radius: 0px;
    border: 2px solid #c9c9ca;
    font-size: 13px;
    line-height: 24px;
    font-family: "Firago-Book";
    padding: 20px;
    color: #4d4d4f;
    transition: 0.4s;

    border-color: #c9c9ca;
    &::placeholder {
      color: rgba(96, 98, 102, 0.8);
    }
    &:focus {
      border-color: black;
    }
  }

  #email_validated {
    position: absolute;
    top: 24px;
    right: 20px;
  }
  .el-select .el-input__inner:focus {
    border-color: black;
  }

  .el-icon-arrow-up:before {
    content: url("../../assets/imgs/arrow.svg");
  }
  .el-select .el-input .el-select__caret {
    transform: rotateZ(90deg);
  }
  .el-select .el-input .el-select__caret.is-reverse {
    transform: rotateZ(90deg);
  }
  .el-select .el-input.is-focus .el-input__inner,
  .el-select .el-input__inner:focus {
    border-color: $black;
  }
  .el-input__icon {
    width: auto;
    margin-right: 15px;
  }

  .el-popper[x-placement^="bottom"] {
    margin-top: 0;
  }
  .el-popper .popper__arrow,
  .el-popper .popper__arrow::after {
    display: none;
  }
  .el-select-dropdown__item.selected {
    color: $black;
  }

  .el-select-dropdown {
    border: 2px solid $black;
    border-top: none;
    border-radius: 0;
    will-change: transform;
  }
  .el-radio,
  .el-radio span {
    color: rgba(96, 98, 102, 0.8);
    // font-family: "Hm-Pangram-bold";
    font-family: "Firago-Book";
  }
  .el-input__prefix {
    left: initial;
    right: 0;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  .el-radio__inner {
    width: 20px;
    height: 20px;
    transition: 0.4s;
    &:hover {
      border-color: #e4e7ed;
    }
  }
  .el-radio__input.is-checked + .el-radio__label,
  .el-radio__input.is-disabled + span.el-radio__label {
    color: rgba(#4d4d4f, 0.3);
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #e4e7ed;
    border-width: 2px;
    background: white;

    &:after {
      background-color: #e4e7ed;
      width: 10px;
      height: 10px;
    }
  }

  .el-input--prefix .el-input__inner {
    padding-left: 20px;
    padding-right: 20px;
  }

  .el-input--suffix .el-input__inner {
    padding-left: 20px;
    padding-right: 20px;
  }

  .el-icon-date {
    &:before {
      content: "";
    }
  }

  .el-checkbox__label {
    // font-family: "Hm-Pangram-bold";
    font-family: "Firago-Book";
  }

  .el-checkbox {
    align-items: center;
    display: flex;
  }

  .el-date-table td.today span,
  .el-date-table td.available:hover {
    color: black;
  }
  .el-date-table td.current:not(.disabled) span {
    background-color: #1a1a1a;
  }

  .el-icon-arrow-up:before {
    opacity: 0.3;
    width: 6px;
    height: 8px;
    content: url("../../assets/imgs/arrow-small.svg");
  }

  .el-select {
    position: relative;
    width: 87px;
    &:after {
      position: absolute;
      content: "";
      top: 20px;
      right: 0;
      height: 20px;
      background-color: #e4e7ed;
      width: 1px;
    }
    input {
      border-right: transparent;
      border: none;
      // border-left: #c9c9ca !important;
    }
  }
  .cabinet-settings__phone-wrapper {
    border: 2px solid #e4e7ed;
    transition: 0.4s;
    input {
      width: 100%;
    }
    .el-input.is-disabled .el-input__inner {
      border: none;
    }
    &.custom_focus {
      border-color: black;
      border: 2px solid black;
    }
    input {
      height: 56px;
      &:nth-child(2) {
        border-left: transparent;
        border: none;
      }
    }

    .el-select {
      position: relative;
      width: 87px;
      &:after {
        position: absolute;
        content: "";
        top: 20px;
        right: 0;
        height: 20px;
        background-color: #c9c9ca;
        width: 1px;
      }
      input {
        border-right: transparent;
        border: none;
        width: 87px;
        // border-left: #c9c9ca !important;
      }
    }
  }
  &__email-wrapper {
    position: relative;
    &--change {
      position: absolute;
      right: 30px;
      top: 23px;
      z-index: 2;
      span {
        color: #4d4d4f;
        font-size: 16px;
      }
      svg {
        margin-top: 3px;
      }
    }
  }
  &__btn {
    background-color: #4d4d4f;
    width: fit-content;
    padding-left: 76px;
    padding-right: 76px;
    height: 60px;
    cursor: pointer;
    transition: 0.4s;
    @include hover {
      background-color: #1a1a1a;
    }
    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }

  @media (max-width: 1550px) {
    width: 770px;
  }
  @media (max-width: 1440px) {
    width: 621px;
  }
  @media (max-width: 1439px) {
    width: 714px;
  }
  @media (max-width: 1365px) {
    width: 100%;
  }
  @media (max-width: 1023px) {
    margin-bottom: 89px;
  }
  @media (max-width: 767px) {
    padding-left: 13px;
    padding-right: 13px;
    &__email-wrapper--change {
      span {
        font-size: 13px;
      }
      right: 10px;
      svg {
        display: none;
      }
    }
  }
  @media (max-width: 413px) {
    padding-left: 13px;
    padding-right: 13px;

    input,
    .el-input--suffix .el-input__inner {
      padding: 10px;
    }
    &__email-wrapper--change {
      span {
        margin-left: 0;
      }
      right: initial;
      left: 0px;
      top: 70px;
      svg {
        display: none;
      }
    }
  }
}
</style>
